import {
  ASSET_SETUP_DATA_STATE,
  ASSET_SETUP_STATE,
  ASSET_STATUS_FILTER_STATE,
  ASSETTYPE_SETUP_STATE,
  AUTHENTICATE_USER_STATE,
  COMPANY_SETUP_STATE,
  EDIT_PERMISSION__STATE,
  EDITASSET_FROM_DATAPROCEESING_STATE,
  GENERIC_FILTER,
  LEVEL1_LEVELNAME_STATE,
  LEVEL1_STATE,
  LEVEL2_LEVELNAME_STATE,
  LEVEL2_STATE,
  LEVEL3_LEVELNAME_STATE,
  LEVEL3_STATE,
  PC_ADMIN__STATE,
  PRIMARY_COMPANY_SETUP_STATE,
  REGION_SETUP_STATE,
  SCREEN_PAGE_SIZE_STATE,
  SEGMENT_SETUP_STATE,
  SEGMENTTYPE_SETUP_STATE,
  SELECTED_COMPANYCONFIG_STATE,
  SELECTED_CURRENTDATAITEM_STATE,
  SELECTED_MTX_Member_STATE,
  SELECTED_USER_STATE,
  SURVEY_OVERVIEW_DATA_STATE,
  CUSTOM_ASSET_TEMPLATE,
  SurveyROUTE_SETUP_STATE,
  TEMPLATE,
  USER_PROFILE_DATA_STATE,
  COMPANY_CONTEXT_STATE,
  IMPORT_COMPANY_CONTEXT,
  METADATA_CHANGE_STATE,
} from '../../shared/constants';
import { AssetSetupState } from './asset-setup.state';
import { AuthenticateUserState } from './authenticate-user.state';
import { LOCAL_STORAGE_ENGINE } from '@ngxs/storage-plugin';
import { StorageKey } from '@ngxs/storage-plugin/internals';
import { CompanyState } from './filter-company';
import { RegionState } from './filter-region';
import { SegmentState } from './filter-segments';
import { SurveyRouteState } from './filter-serveyrotes';
import { AssetTypeState } from './filter-assettype';
import { Level1State } from './filter-level1.state';
import { Level2State } from './filter-level2.state';
import { Level3State } from './filter-level3.state';
import { SegmentTypeState } from './filter-segmenttype.state';
import { PrimaryCompanyState } from './primary-company';
import { SetupHierarchyState } from './setup-hierarchy.state';
import { SelectedUserState } from './selectedUser.state';
import { AssetSetupDataState } from './asset.state';
import { SurveyOverviewDataState } from './survey-overview.state';
import { CustomAssetTemplateState } from './customAssetTemplate.state';
import { SurveyRouteDataState } from './survey-route.state';
import { UserProfileDataState } from './user-profile.state';
import { SelectedMTX_MemberState } from './MTX_Member.state';
import { PCAdminDataState } from './user-admin.state.state';
import { Level1LevelNameState } from './filter-level1Name.state';
import { Level2LevelNameState } from './filter-level2Name.state';
import { Level3LevelNameState } from './filter-level3Name.state';
import { TemplateState } from './template.state';
import { EditAssetFromDataProcessingStoreState } from './edit-asset-from-data-processing-store';
import { DataProcessignState } from './data-processing.state';
import { ScreenPageSizeState } from './screen-pageSize.state';
import { EditPermissionState } from './edit-permission.state';
import { SelectedCurrentDataItem } from './current-dataItem.state';
import { GenericFilter } from './generic-filtet.state';
import { SurveyFilterState } from './survey-filter.state';
import { AssetStatusFilterState } from './filter-asset-status.state';
import { SelectedcompanyConfigData } from './company-config.state';
import { CompanyContextState } from './company-context.state';
import { ImportCompanyContextState } from './import-company.state';
import { MetadataChangeState } from './metadata-change.state';
import { AssetSelectionGridState } from './asset-selection-grid.state';
import { SurveyGridState } from './survey-grid.state';

export const states = [
  AuthenticateUserState,
  AssetSetupState,
  CompanyState,
  RegionState,
  SegmentState,
  SurveyRouteState,
  AssetTypeState,
  Level1State,
  Level2State,
  Level3State,
  SegmentTypeState,
  PrimaryCompanyState,
  SetupHierarchyState,
  SelectedUserState,
  AssetSetupDataState,
  SurveyOverviewDataState,
  CustomAssetTemplateState,
  SurveyRouteDataState,
  UserProfileDataState,
  SelectedMTX_MemberState,
  PCAdminDataState,
  Level1LevelNameState,
  Level2LevelNameState,
  Level3LevelNameState,
  TemplateState,
  EditAssetFromDataProcessingStoreState,
  DataProcessignState,
  ScreenPageSizeState,
  EditPermissionState,
  SelectedCurrentDataItem,
  GenericFilter,
  SurveyFilterState,
  SelectedcompanyConfigData,
  CompanyContextState,
  ImportCompanyContextState,
  MetadataChangeState,
  AssetSelectionGridState,
  SurveyGridState,
  AssetStatusFilterState,
];

export const statesToStoreInLocalStorage: StorageKey[] = [
  AuthenticateUserState,
  AssetSetupState,
  CompanyState,
  RegionState,
  SegmentState,
  SurveyRouteState,
  AssetTypeState,
  Level1State,
  Level2State,
  Level3State,
  SegmentTypeState,
  PrimaryCompanyState,
  SetupHierarchyState,
  SelectedUserState,
  AssetSetupDataState,
  SurveyOverviewDataState,
  CustomAssetTemplateState,
  SurveyRouteDataState,
  UserProfileDataState,
  SelectedMTX_MemberState,
  PCAdminDataState,
  Level1LevelNameState,
  Level2LevelNameState,
  Level3LevelNameState,
  TemplateState,
  EditAssetFromDataProcessingStoreState,
  DataProcessignState,
  ScreenPageSizeState,
  EditPermissionState,
  SelectedCurrentDataItem,
  GenericFilter,
  SurveyFilterState,
  SelectedcompanyConfigData,
  CompanyContextState,
  ImportCompanyContextState,
  AssetStatusFilterState,
];

export enum enStateName {
  AuthenticateUserState = AUTHENTICATE_USER_STATE,
  AssetSetupState = ASSET_SETUP_STATE,
  CompanyState = COMPANY_SETUP_STATE,
  RegionState = REGION_SETUP_STATE,
  SegmentState = SEGMENT_SETUP_STATE,
  SurveyRouteState = SurveyROUTE_SETUP_STATE,
  AssetTypeState = ASSETTYPE_SETUP_STATE,
  Level1State = LEVEL1_STATE,
  Level2State = LEVEL2_STATE,
  Level3State = LEVEL3_STATE,
  SegmentTypeState = SEGMENTTYPE_SETUP_STATE,
  PrimaryCompanyState = PRIMARY_COMPANY_SETUP_STATE,
  SetupHierarchyState = 'setupHierarchy',
  SelectedUserState = SELECTED_USER_STATE,
  AssetSetupDataState = ASSET_SETUP_DATA_STATE,
  SurveyOverviewDataState = SURVEY_OVERVIEW_DATA_STATE,
  CustomAssetTemplateState = CUSTOM_ASSET_TEMPLATE,
  SurveyRouteDataState = 'surveyRouteDataSetup',
  UserProfileDataState = USER_PROFILE_DATA_STATE,
  SelectedMTX_MemberState = SELECTED_MTX_Member_STATE,
  PCAdminDataState = PC_ADMIN__STATE,
  Level1LevelNameState = LEVEL1_LEVELNAME_STATE,
  Level2LevelNameState = LEVEL2_LEVELNAME_STATE,
  Level3LevelNameState = LEVEL3_LEVELNAME_STATE,
  TemplateState = TEMPLATE,
  EditAssetFromDataProcessingStoreState = EDITASSET_FROM_DATAPROCEESING_STATE,
  DataProcessignState = 'dataProcessing',
  ScreenPageSizeState = SCREEN_PAGE_SIZE_STATE,
  EditPermissionState = EDIT_PERMISSION__STATE,
  SelectedCurrentDataItem = SELECTED_CURRENTDATAITEM_STATE,
  GenericFilterValue = GENERIC_FILTER,
  SurveyFilterState = 'surveyFilter',
  SelectedcompanyConfigData = SELECTED_COMPANYCONFIG_STATE,
  CompanyContextState = COMPANY_CONTEXT_STATE,
  ImportCompanyContextState = IMPORT_COMPANY_CONTEXT,
  MetadataChangeState = METADATA_CHANGE_STATE,
  AssetStatusFilterState = ASSET_STATUS_FILTER_STATE,
}

export const storageSettingForStore: StorageKey[] = [
  {
    key: enStateName.AuthenticateUserState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SetupHierarchyState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.AssetSetupState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.CompanyState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.RegionState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SegmentState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SurveyRouteState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.AssetTypeState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.TemplateState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.Level1State,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.Level2State,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.Level3State,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SegmentTypeState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.PrimaryCompanyState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SelectedUserState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.AssetSetupDataState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SurveyOverviewDataState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.CustomAssetTemplateState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SurveyRouteDataState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.UserProfileDataState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SelectedMTX_MemberState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.PCAdminDataState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.Level1LevelNameState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.Level2LevelNameState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.Level3LevelNameState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.EditAssetFromDataProcessingStoreState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.DataProcessignState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.ScreenPageSizeState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.EditPermissionState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SelectedCurrentDataItem,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.GenericFilterValue,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SurveyFilterState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SelectedcompanyConfigData,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.SelectedcompanyConfigData,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.CompanyContextState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.ImportCompanyContextState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: enStateName.AssetStatusFilterState,
    engine: LOCAL_STORAGE_ENGINE,
  },
];
